module.exports = __webpack_public_path__ + "media/אריה.fbe17d1e.mp3";